module.exports = __webpack_public_path__ + "assets/icon-clone.f351a8c1.svg";